// @flow
import React, { useState } from 'react'
import ProviderPreviews from './ProviderPreviews'
import { Header } from './controls'
import { translations, translateFunc } from '../../shared/localize'
import AdvertisementPreviewSwitcher from './AdvertisementPreviewSwitcher'
import type { AudienceData } from '../types'

import { Audience } from '../constants'
import TagSwitcher, { calculateTag } from './ProviderPreviews/TagSwitcher'
import type { PreviewData } from './NamedPreview'

const t = translateFunc(translations.ad_edit)

export type Props = {|
  audienceData: AudienceData,
  previewDataCollection: Array<PreviewData>,
  dispatch: any, // eslint-disable-line react/no-unused-prop-types
  storeIds: any // eslint-disable-line react/no-unused-prop-types
|}

export default function SwitchableProviderPreview(props: Props) {
  const { previewDataCollection, audienceData } = props

  const [statePreviewIndex, setStatePreviewIndex] = useState(0)

  if (previewDataCollection.length === 0) return null
  if (
    audienceData.audienceType === Audience.types.product_retargeting ||
    audienceData.audienceType === Audience.types.posts_promotion
  )
    return null

  const previewData = previewDataCollection[previewIndex(props, statePreviewIndex)]

  return (
    <div>
      <Header>{t('previews')}</Header>
      {previewDataCollection.length > 1 && (
        <AdvertisementPreviewSwitcher
          previews={previewDataCollection}
          selectedIndex={previewIndex(props, statePreviewIndex)}
          onChange={(index: number) => {
            setStatePreviewIndex(index)
          }}
        />
      )}
      <TagSwitcher
        namesRenderer={(names) => <ProviderPreviews names={names} data={previewData} />}
        providers={props.audienceData.providers}
        fbPlacements={props.audienceData.fbPlacements}
        maxPreviewTag={calculateTag(audienceData.audienceType, audienceData.placementType)}
        hideSwitcher={audienceData.placementType !== Audience.placement_types.column}
      />
    </div>
  )
}

function previewIndex(props: Props, statePreviewIndex: number): number {
  const { previewDataCollection } = props

  if (statePreviewIndex < previewDataCollection.length) return statePreviewIndex

  return 0
}
